export class Plant {
    id:string = ""
    name:string = ""
    longitude?: number = undefined
    latitude?: number = undefined
    email:string = ""
    houseNumber:string = ""
    applicationRadius?: number = undefined
    street:string = ""
    postalcode:string = ""
    city:string = ""
    phoneNumber:string = ""
}